import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const ItemSwitch = ({
  itemOneText,
  itemTwoText,
  switchText,
  switchAction,
  switchValue,
  showSwitchText = true,
}) => {
  return (
    <div className="col-lg-12 switch">
      <div className={`swipe_content ${switchValue ? "left" : "right"}`}>
        <button
          type="button"
          className="full_space"
          onClick={() => switchAction(!switchValue)}
        ></button>
        <div className="titles">
          <span style={{ marginLeft: "8px" }}>{itemOneText}</span>
          <span>{itemTwoText}</span>
        </div>
        <div className="buttons">
          <div className="button">
            <FontAwesomeIcon size="lg" icon={faCaretLeft} />
            {showSwitchText && (
              <span style={{ marginTop: "-2px" }}>{switchText}</span>
            )}
            <FontAwesomeIcon size="lg" icon={faCaretRight} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ItemSwitch;
